import Image from 'global/Image';
import PropTypes from 'prop-types';

const PortraitAvatar = ({
  avatar: avatarProps,
  temp_avatar: tempAvatar,
  hide_loader: hideLoader,
  avatarURL,
}) => {
  let image;

  if (avatarProps) {
    if (avatarProps.match(/\bhttp/i)) {
      image = avatarProps;
    } else {
      image = `${avatarURL}/${avatarProps}`;
    }
  } else {
    image = null;
  }

  const avatar = tempAvatar || image;
  let clsLoader = '';

  if (hideLoader && avatar) clsLoader = 'hide';

  return (
    <div>
      <div className={`PrimarySpinner ${clsLoader}`} />
      <i>
        <Image alt="avatar" src={avatar} />
      </i>
    </div>
  );
};

PortraitAvatar.propTypes = {
  avatar: PropTypes.string,
  temp_avatar: PropTypes.string,
  hide_loader: PropTypes.bool,
  avatarURL: PropTypes.string.isRequired,
};

PortraitAvatar.defaultProps = {
  avatar: '',
  temp_avatar: '',
  hide_loader: true,
};

export default PortraitAvatar;
